export default [
  // ============================
  // ⚙️ Manage-jobs Routes
  // ============================

  {
    path: "/manage-jobs/vacncies",
    name: "jobList",
    meta: { title: "List Job", requiresAuth: true },
    component: () => import("../views/main/employer/manage-jobs/vacncies.vue"),
  },
  {
    path: "/manage-jobs/job-create",
    name: "createJob",
    meta: { title: "New Job", requiresAuth: true },
    component: () =>
      import("../views/main/employer/manage-jobs/job-create.vue"),
  },
  {
    path: "/manage-jobs/job-update/:code",
    name: "updateJob",
    meta: { title: "Update Job", requiresAuth: true },
    component: () =>
      import("../views/main/employer/manage-jobs/job-update.vue"),
  },
  {
    path: "/jobs-details/:code",
    name: "jobDetails",
    meta: { title: "Job Details", requiresAuth: true },
    component: () =>
      import("../views/main/employer/manage-jobs/job-details.vue"),
  },
  {
    path: "/manage-jobs/job-application/:code",
    name: "applicationDetails",
    meta: { title: "Application List", requiresAuth: true },
    component: () =>
      import("../views/main/employer/manage-jobs/applicants/index.vue"),
  },
];
